import React from 'react';

interface MenuIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const MenuIcon: React.FC<MenuIconProps> = ({
  width = 28,
  height = 32,
  color = 'black',
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0 5.5C0 4.66875 0.66875 4 1.5 4H26.5C27.3312 4 28 4.66875 28 5.5C28 6.33125 27.3312 7 26.5 7H1.5C0.66875 7 0 6.33125 0 5.5ZM0 16C0 15.1687 0.66875 14.5 1.5 14.5H26.5C27.3312 14.5 28 15.1687 28 16C28 16.8313 27.3312 17.5 26.5 17.5H1.5C0.66875 17.5 0 16.8313 0 16ZM28 26.5C28 27.3312 27.3312 28 26.5 28H1.5C0.66875 28 0 27.3312 0 26.5C0 25.6688 0.66875 25 1.5 25H26.5C27.3312 25 28 25.6688 28 26.5Z"
      fill={color}
    />
  </svg>
);

export default MenuIcon;
